import { Injectable, inject } from '@angular/core';
import { LenderProductDetailsViewModel, MatchedLenderProducts, Product, ProductsBtlModelRequest } from '@shared/models';
import { ClubHubDataService } from '@shared/services';
import { Observable, tap } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
/* Get data only for BTL products */
export class ProductsSearchBtlService {
  private readonly dataService = inject<ClubHubDataService>(ClubHubDataService);

  public getProducts(scheduled: boolean, btlProductsModelRequest?: ProductsBtlModelRequest): Observable<MatchedLenderProducts[]> {
    return this.dataService.post<MatchedLenderProducts[]>(`Product/?scheduled=${scheduled}`, btlProductsModelRequest).pipe(
      tap(products => {
        const loanAmount = btlProductsModelRequest?.loanAmount;
        if (!loanAmount) {
          return;
        }

        for (const product of products.flatMap(lp => lp.products)) {
          if (typeof product.maximumAffordableLoanAmount === 'number') {
            product.lenderAffordabilityMet = product.maximumAffordableLoanAmount >= loanAmount ? 'Pass' : 'Fail';
          }
        }
      }),
    );
  }

  public getAllProducts(productsModelRequest: ProductsBtlModelRequest): Observable<Product[]> {
    return this.dataService.post<Product[]>('product/GetAllProducts/ResiBtl', productsModelRequest);
  }

  public getLenderProductDetails(
    product: Product,
    loanAmount: number | null,
    lenderName: string,
    lendingTypeId: number,
  ): Observable<LenderProductDetailsViewModel> {
    return this.dataService.post<LenderProductDetailsViewModel>(`esisInformation/lender/${lenderName}/${lendingTypeId}`, {
      loanAmount,
      product,
      isBridgingProduct: false,
    });
  }
}
